import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios';
import Cookies from "js-cookie";


const httpClientFactory = (configService) => {

    const httpClient = axios.create({
        baseURL: `${process.env.REACT_APP_API_URL}`,
        timeout: 30000
    });

    const authHeaderInterceptor = async (config)=> {
        const token = Cookies.get('token');

        if (token && config.headers) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    };


    const errorsHandlerInterceptor = (response) => {
        if (response.status === 401) {
            const errorText = response.data?.message || response.statusText;
            throw new Error(errorText);
        }

        return response;
    };

    httpClient.interceptors.request.use(authHeaderInterceptor);
    httpClient.interceptors.response.use(errorsHandlerInterceptor);

    return httpClient;
};


export default httpClientFactory;
